import mirror from 'keymirror';
import Stats from '../lib/stats';

export const actionTypes = mirror({
  STATS_GET_ERROR: null,
  STATS_GET_IN_PROGRESS: null,
  STATS_GET_LEVELS_SUCCESS: null,
});

const statsGetError = error => ({
  error,
  type: actionTypes.STATS_GET_ERROR,
});

const statsGetInProgress = () => ({
  type: actionTypes.STATS_GET_IN_PROGRESS,
});

const statsGetLevelsSuccess = results => ({
  results,
  type: actionTypes.STATS_GET_LEVELS_SUCCESS,
});

export const getLevelStats = levelIdArr => async dispatch => {
  try {
    dispatch(statsGetInProgress());
    const results = await Stats.getLevelStats(levelIdArr);
    dispatch(statsGetLevelsSuccess(results));
  } catch (err) {
    dispatch(statsGetError(err));
  }
};
